<template>
  <div>
    <Navbar />
    <Breadcrumb />
    <div class="card mx-auto col-lg-10 col-md-12 col-sm-12 border-0">
      <div class="card-title mb-4 pb-4">
        <div class="row">
          <span class="survey-type-badge btn-primary mr-2">
            <fa-icon
              icon="file-medical-alt"
              size="6x"
            />
          </span>
          <span>
            Test
          </span>
        </div>
      </div>
      <div
        class="mx-auto col-9"
      >
        <h4>Test Nets Payment</h4>
        <div class="mb-3">
          <button
            class="btn btn-primary"
            @click="resetpaymentid"
          >
            Reset payment ID
          </button>
          {{ netspayment_id }}
        </div>
        <div class="mb-3">
          <input
            class="form-control"
            v-model="order_id"
            placeholder="Order ID"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">I want to pay by:</label>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              v-model="payment"
              name="payment"
              id="payment-nets"
              value="4"
            >
            <label class="form-check-label" for="payment-nets">
              Nets Credit Card - DEV ONLY
            </label>
          </div>
        </div>
        <!-- NETS Easy Payment -->
        <div v-if="payment === 4">
          <NetsPayment
            product-name="GDQ Report"
            :dibs-amount="100"
            :order-id="order_id"
            :accept-url="web_url"
            :cancel-url="web_url"
          />
        </div>

        <!-- Google Slides Embed Test -->
        <div class="mt-5">
          <h4>Google Viewer Test</h4>
          <div class="mb-3">
            <input
              class="form-control"
              v-model="slidesFileId"
              placeholder="Google File ID"
            />
            <small class="form-text text-muted">
              File ID from URL: drive.google.com/file/d/{FILE_ID}/view
            </small>
          </div>
          <div class="mb-3">
            <button
              class="btn btn-primary"
              @click="testEmbed = !testEmbed"
            >
              {{ testEmbed ? 'Hide Embed' : 'Show Embed' }}
            </button>
            <button
              class="btn btn-secondary ms-2"
              @click="openInNewTab"
            >
              Open in New Tab
            </button>
          </div>
          <div
            v-if="testEmbed"
            class="mt-3"
          >
            <h5>Drive Viewer (PPTX compatible)</h5>
            <div style="border: 1px solid #ddd; border-radius: 4px; overflow: hidden;">
              <iframe
                :src="driveViewerUrl"
                width="100%"
                height="600"
                frameborder="0"
                style="border: none;"
                allowfullscreen
              ></iframe>
            </div>
            <small class="form-text text-muted">
              {{ driveViewerUrl }}
            </small>
            <h5 class="mt-4">Slides Publish Embed (requires published presentation)</h5>
            <div style="border: 1px solid #ddd; border-radius: 4px; overflow: hidden;">
              <iframe
                :src="slidesEmbedUrl"
                width="100%"
                height="600"
                frameborder="0"
                style="border: none;"
                allowfullscreen
              ></iframe>
            </div>
            <small class="form-text text-muted">
              {{ slidesEmbedUrl }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar'
import Breadcrumb from './Breadcrumb'
import NetsPayment from './NetsPayment'
import { config } from '../../config'

export default {
  name: 'Test',
  components: {
    Navbar,
    Breadcrumb,
    NetsPayment
  },
  data () {
    return {
      order_id: 0,
      payment: null,
      netspayment_id: this.$route.query.paymentid ? this.$route.query.paymentid : '',
      nets_paid_amount: 0,
      nets_invoice_amount: 0,
      base_url: config.base_url,
      web_url: window.location + '',
      slidesFileId: '1Znvqe7tEAmlbzprrPDtX5pPIsa7Z3o2p',
      testEmbed: false
    }
  },
  computed: {
    gdq_url: function () {
      const url = window.location
      return url
    },
    driveViewerUrl: function () {
      return `https://drive.google.com/file/d/${this.slidesFileId}/preview`
    },
    slidesEmbedUrl: function () {
      return `https://docs.google.com/presentation/d/${this.slidesFileId}/pub/embed`
    }
  },
  created () {
    this.checknetspayment()
  },
  methods: {
    resetpaymentid () {
      this.$store.dispatch('netspayment_set', { current_netspayment_id: '' })
    },
    openInNewTab () {
      const url = `https://drive.google.com/file/d/${this.slidesFileId}/view`
      window.open(url, '_blank')
    },
    checknetspayment () {
      if (this.netspayment_id !== '') {
        // Update the invoice and payment_lof
        this.$store.dispatch('netspayment_update', { paymentId: this.netspayment_id })
          .then((resp) => {
            if (resp.data.status === 'OK') {
              console.log(resp.data)
            } else {
              alert(resp.data.error)
            }
          })
      }
    }
  }
}
</script>
<style scoped></style>
<style>
.hidden_header {
  display: none;
}
</style>
